module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.82f3321ed34e3918223e.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/assets/Material-Design-Iconic-Font.woff
// module id = ../../../../../src/assets/Material-Design-Iconic-Font.woff
// module chunks = main styles